enum LogLevel {
    DEBUG = 0,
    INFO = 1,
    WARNING = 2,
    ERROR = 3
  }
  
  class Logger {
    private static logLevel: LogLevel = process.env.REACT_APP_ENV === 'development' ? LogLevel.DEBUG : LogLevel.ERROR;
  
    static debug(message: string, context?: any): void {
      if (Logger.logLevel <= LogLevel.DEBUG) {
        // Logger.log('\x1b[36mDEBUG\x1b[0m', message, context);
      }
    }
  
    static info(message: string, context?: any): void {
      if (Logger.logLevel <= LogLevel.INFO) {
        // Logger.log('\x1b[32mINFO\x1b[0m', message, context);
      }
    }
  
    static warning(message: string, context?: any): void {
      if (Logger.logLevel <= LogLevel.WARNING) {
        // Logger.log('\x1b[33mWARNING\x1b[0m', message, context);
      }
    }
  
    static error(message: string, context?: any): void {
      if (Logger.logLevel <= LogLevel.ERROR) {
        // Logger.log('\x1b[31mERROR\x1b[0m', message, context);
      }
    }
  
    private static log(level: string, message: string, context?: any): void {
      const timestamp = new Date().toISOString();
      const logMessage = `[${timestamp}] ${level} ${message}`;
  
      // Include contextual information if provided
      if (context) {
        console.log(`${logMessage} - Context:`, context);
      } else {
        console.log(logMessage);
      }
    }
  }
  
  export default Logger;
  